/* eslint-disable @typescript-eslint/no-explicit-any */

import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";

import type { IGroupParams } from "./useTableParams";

export const useParamsFromUrl = (
  setTableParams: (updater: React.SetStateAction<IGroupParams>) => void,
  keys: (keyof IGroupParams)[]
) => {
  const location = useLocation();

  const valuesFromUrl = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    const result: Partial<IGroupParams> = {};
    keys.forEach(key => {
      const value = searchParams.get(key as string);
      if (value) result[key] = value as any;
    });
    return result;
  }, [location.search]);

  useEffect(() => {
    if (Object.keys(valuesFromUrl).length > 0) {
      setTableParams(prev => {
        const hasChanges = Object.entries(valuesFromUrl).some(
          ([key, value]) => prev[key] !== value
        );
        if (!hasChanges) {
          return prev;
        }
        return {
          ...prev,
          ...valuesFromUrl,
          offset: 0,
        };
      });
    }
  }, [valuesFromUrl, setTableParams]);

  return valuesFromUrl;
};
